import { MutationTree } from 'vuex'
import State, { ICountry, ICountryState, IIncoTerm } from './types'

export const mutations: MutationTree<State> = {
  countriesLoaded(state, countries: ICountry[]) {
    state.Error = false
    state.countries = countries
  },
  countriesError(state) {
    state.Error = true
    state.countries = []
  },
  countryStatesLoaded(state, countryStates: ICountryState[]) {
    state.Error = false
    state.countryStates = countryStates
  },
  countryStatesError(state) {
    state.Error = true
    state.countryStates = []
  },
  storageLocationsLoaded(state, locations: string[]) {
    state.Error = false
    state.storageLocations = locations
  },
  storageLocationsError(state) {
    state.Error = true
    state.storageLocations = []
  },
  incoTermsLoaded(state, terms: IIncoTerm[]) {
    state.Error = false
    state.incoTerms = terms
  },
  incoTermsError(state) {
    state.Error = true
    state.incoTerms = []
  },
  overlayLoadingSet(state, isShowing: boolean) {
    state.showLoadingOverlay = isShowing
  },
  hideBreadcrumbSet(state, isHide: boolean) {
    state.hideBreadcrumbs = isHide
  },
}
